import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

interface ContactInfo {
  phone: string;
  email: string;
  address_ar: string;
  address_en: string;
  whatsapp: string;
  working_hours_ar: string;
  working_hours_en: string;
}

interface SocialLinks {
  facebook: string;
  twitter: string;
  instagram: string;
  linkedin: string;
  whatsapp: string;
}

const defaultContact: ContactInfo = {
  phone: '+965 1234 5678',
  email: 'info@ghadeerlaw.com',
  address_ar: 'الكويت',
  address_en: 'Kuwait',
  whatsapp: '+96512345678',
  working_hours_ar: 'الأحد - الخميس: 9:00 - 17:00',
  working_hours_en: 'Sun - Thu: 9:00 - 17:00',
};

const defaultSocial: SocialLinks = {
  facebook: '#',
  twitter: '#',
  instagram: '#',
  linkedin: '#',
  whatsapp: 'https://wa.me/96512345678',
};

export const useContactInfo = () => {
  const [contactInfo, setContactInfo] = useState<ContactInfo>(defaultContact);
  const [socialLinks, setSocialLinks] = useState<SocialLinks>(defaultSocial);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadData = async () => {
    try {
      const [contactRes, socialRes] = await Promise.all([
        supabase
          .from('site_settings')
          .select('setting_value')
          .eq('setting_key', 'contact_info')
          .maybeSingle(),
        supabase
          .from('site_settings')
          .select('setting_value')
          .eq('setting_key', 'social_links')
          .maybeSingle(),
      ]);

      if (contactRes.data?.setting_value) {
        const fetchedContact = typeof contactRes.data.setting_value === 'object'
          ? contactRes.data.setting_value
          : {};
        setContactInfo({ ...defaultContact, ...fetchedContact });
      }

      if (socialRes.data?.setting_value) {
        const fetchedSocial = typeof socialRes.data.setting_value === 'object'
          ? socialRes.data.setting_value
          : {};
        setSocialLinks({ ...defaultSocial, ...fetchedSocial });
      }
    } catch (error) {
      console.error('Error loading contact info:', error);
    } finally {
      setLoading(false);
    }
  };

  return { contactInfo, socialLinks, loading };
};
